import React from 'react'
import { Trans } from 'react-i18next'

import { Button } from '@makyoapp/makyo-tw-ui'
import { SimpleInput } from '@makyoapp/makyo-ui'

export default function RowContextInput({
  rowIndex,
  handleRowIndexChange,
  handleSimulate,
  isLoading,
}: {
  rowIndex: string
  handleRowIndexChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleSimulate: () => void
  isLoading: boolean
}) {
  return (
    <div>
      <div className='text-sm font-medium text-gray-900 dark:text-white mb-2'>
        <Trans>Row Context:</Trans>
      </div>
      <div className='flex items-center gap-2'>
        <SimpleInput
          type='text'
          value={rowIndex}
          placeholder='Enter Row Number'
          onChange={handleRowIndexChange}
          className='flex-1 border border-gray-200 dark:border-gray-700 rounded'
          noBorder={false}
        />
        <Button onClick={handleSimulate} disabled={isLoading} size='sm' className='whitespace-nowrap'>
          {isLoading ? <Trans>Simulating...</Trans> : <Trans>Simulate</Trans>}
        </Button>
      </div>
      <div className='text-xs text-gray-500 dark:text-gray-400 mt-1'>
        <Trans>Use positive numbers (1, 2, 3...) or negative (-1 for last row)</Trans>
      </div>
    </div>
  )
}
